<template>
    <div class="product_item_content_media" :data-indicador="indicador" :id="'product_item_content_media_'+indicador">
        <div class="product_gallery_slider" :data-indicador="indicador" :id="'product_gallery_slider'+indicador">
            <ul :data-indicador="indicador" v-if="gallery && gallery.length>0" :id="'product_gallery_slider_list_'+indicador">
                <li v-for="(g, gIdx) in gallery" :key="gIdx"
                    :id="'gellery_'+indicador+'_item_'+g.id"
                    :class="['gellery_'+indicador+'_items', (itemId==g.id) ? 'active' : '']"
                    :data-indicador="indicador"
                    :data-itemg="g.id">
                    <span class="gallery_item_index">{{ gIdx + 1 }} / {{ gallery.length }}</span>
                    <img v-if="g.type_file=='img'" class="product_item_img" :src="urlMedia+'/img/'+g.name_file" alt="" :data-indicador="indicador">
                    <video v-else :src="urlMedia+'/video/'+g.name_file" controls muted loop preload="auto" :poster="urlMedia+'/video/'+g.name_file+'.jpg'" class="product_item_video" :data-indicador="indicador"></video>
                </li>
            </ul>
            <ul v-else>
                <li class="slide_default" :data-indicador="indicador" @click.prevent="$emit('editGallery', {name: 'productUpload', data: {productItem, urlMedia}})">
                    <i class="fas fa-photo-video icon_default"></i>
                </li>
            </ul>
        </div>
        <div class="product_item_btns">
            <button class="btn-edit" @click.prevent="$emit('editGallery', {name: 'productUpload', data: {productItem, urlMedia}})">{{ lang.bs_edit }}</button>
        </div>
        <button class="btn btn-danger btnDelproduct" :title="lang.bssl_delete_product"  @click="$parent.$emit('delproduct', productItem)"><i class="fas fa-trash"></i></button>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: ['productItem', 'indicador', 'gallery', 'urlMedia'],
    data(){
        return {
            itemId: null,
            lang: {
                bs_edit: '',
                bssl_delete_product: '',
            },
        };
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
        }),
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
        gallery(){
            let t = this;
            t.itemId = (t.gallery && t.gallery.length>0) ? t.gallery[0].id : 0;
        }
    },
    mounted(){
        let t = this;
        t.lang = t.$store.getters['ModApps/Marketea/lang'];
        t.itemId = (t.gallery && t.gallery.length>0) ? t.gallery[0].id : 0;
    },
    methods: {
        indicadorSlider(ids){
            console.log('indicadorSlider', ids);
            this.itemId = ids;
            this.$emit('clickNav', {SliderId: ids, indicador: this.indicador});
        },
    }
}
</script>
<style lang="scss" scoped>
.product_gallery_slider ul li {
    position: relative;
    .gallery_item_index {
        position: absolute;
        left: 10px;
        top: 10px;
        background: rgba(255, 255, 255, 0.5);
        padding: 2px 20px;
        border-radius: 20px;
        box-shadow: 1px 1px 5px rgb(0 0 0 / 15%);
        opacity: 0.8;
    }
}
</style>
